<template>
	<el-container class="home">
		<el-header style="height: 75px;">
			<my-header></my-header>
		</el-header>
		<el-main class="fullpage homepage">
			<div class="mySwiper">
				<router-view></router-view>
				<div class="rightBar">
					<div class="bottom">
						<div class="advisor">
							<div class="advisorBox">
								<div class="item" @click="qyzx=true">企业服务咨询</div>
								<div class="item" @click="grzx=true">个人服务咨询</div>
							</div>
						</div>
						<div class="program">
							<div class="programC"></div>
						</div>
						<div class="cellphone">
							<div class="cellphoneC">
								<img src="../assets/images/img/dh.png" width="14" />
								<span>400-700-9161</span>
							</div>
						</div>
						<!-- <div v-if="binFlag" class="up" @click="backTop"></div> -->
					</div>
				</div>
			</div>
		</el-main>
		<div class="modal" v-show="qyzx">
			<div class="modalBox">
				<div class="closeBtn" @click="qyzx=false">
					<i class="fa fa-close" style="color: #FF8500;font-size: 14px;"></i>
				</div>
				<div class="logo">
					<img alt="" src="../assets/modal-logo.png" width="120" height="119">
				</div>
				<div class="isCompany">
					<div class="tImg">
						<span>➣</span>企业服务咨询
					</div>
					<div class="item"><input type="text" placeholder="企业名称" v-model="qycompyname"></div>
					<div class="item"><input type="text"  placeholder="联系人职位" v-model="qyjob"></div>
					<div class="item"><input type="text"  placeholder="联系人姓名" v-model="qyname"></div>
					<div class="item"><input type="text"  placeholder="联系人手机号" v-model="qylx"></div>
					<div class="item"><input type="text" placeholder="联系人邮箱" v-model="qyemali"></div>
					<div class="item"><textarea rows="3" placeholder="咨询内容" type="text" v-model="qynr"></textarea></div>
					<div class="item" style="font-size: 14px;color: #999;">注：递交咨询信息后，2-3三个工作日内将有专属销售经理回复您,请保证通讯畅通哦！也可拨打客服热线咨询：400-700-9161，021-31770068</div>
					<div class="subBtn" @click="qySubmit">确认提交</div>
				</div>
			</div>
		</div>
		<div class="modal" v-show="grzx">
			<div class="modalBox">
				<div class="closeBtn" @click="grzx=false">
					<i class="fa fa-close" style="color: #FF8500;font-size: 14px;"></i>
				</div>
				<div class="logo">
					<img alt="" src="../assets/modal-logo.png" width="120" height="119">
				</div>
				<div class="isCompany">
					<div class="tImg">
						<span>➣</span>个人服务咨询
					</div>
					<div style="margin-top: 18%;">
						<div class="item">如果您在使用过程中遇到问题或咨询其他问题</div>
						<div class="item">可拨打客服热线咨询：</div>
						<div class="item">400-700-9161（7×24小时服务）</div>
						<div class="item">021-31770068（周一 ~ 周五 9:00 ~ 17:30）</div>
					</div>
					<!-- <div class="item"><input placeholder="联系人姓名" v-model="grname"></div>
					<div class="item"><input placeholder="联系方式" v-model="grlx"></div>
					<div class="item"><textarea rows="3" placeholder="咨询内容" type="text" v-model="grnr"></textarea></div>
					<div class="subBtn" @click="submitForm">确认提交</div> -->
				</div>
			</div>
		</div>

	</el-container>
</template>

<script>
	export default {
		name: 'Home',
		data() {
			return {
				scrollTop: '',
				binFlag: false,
				qyzx: false,
				grzx: false,
				grname: '', // 联系人
				grlx: '', // 联系人联系方式
				grnr: '', //咨询内容
				qycompyname: '', //企业名称
				qyjob: '', //联系人职位
				qyname: '', //联系人姓名
				qylx: '', //联系方式
				qyemali: '', //联系邮箱
				qynr: '', //咨询内容
			}
		},
		mounted() {
			window.addEventListener('scroll', this.scrollToTop)
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollToTop)
		},
		methods: {
			// 个人咨询
			submitForm() {
				if (this.grname == '') {
					alert('请输入联系人姓名')
				} else if (this.grlx == '') {
					alert('请输入联系方式')
				} else if (this.grnr == '') {
					alert('请填写咨询内容')
				} else {
					console.log(this.grname, this.grlx, this.grnr)
				}
			},
			// 企业咨询
			qySubmit() {
				console.log(this.qyemali)
				if (this.qycompyname == '') {
					alert('请输入企业姓名')
				} else if (this.qyjob == '') {
					alert('请输入联系人职位')
				} else if (this.qyname == '') {
					alert('请输入联系人姓名')
				} else if (this.qylx == '') {
					alert('请输入联系人手机号')
				} else if (this.qynr == '') {
					alert('请填写咨询内容')
				} else {
					// console.log(this.qycompyname, this.qyjob, this.qyname, this.qylx, this.qynr,this.qyemali)
					let that = this
					this.$axios.post('/Ask/Submit', {
						"Data": {
							"CompanyName": that.qycompyname,
							"ContactName": that.qyname,
							"Position": that.qyjob,
							"Phone": that.qylx,
							"AskContent": that.qynr,
							"Email":that.qyemali
						}
					}).then((res) => {
						console.log(res)
						if (res.data.Code == 0) {
							that.qyzx = false
							that.$message({
								type: 'success',
								message: '已递交咨询信息，将于2-3个工作日内回复您，请保持通讯畅通哦！'
							})
						} else {
							that.$message({
								type: 'info',
								message: res.data.Message
							})
						}
					})
				}
			},
			//返回顶部
			backTop() {
				const that = this
				let timer = setInterval(() => {
					let isPeed = Math.floor(-that.scrollTop / 5)
					document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + isPeed
					if (that.scrollTop === 0) {
						clearInterval(timer)
					}
				}, 16)
			},
			//计算顶部距离
			scrollToTop() {
				const that = this
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
				that.scrollTop = scrollTop
				if (that.scrollTop > 10) {
					that.binFlag = true
				} else {
					that.binFlag = false
				}
			}
		}
	}
</script>

<style>
	.modal {
		width: 100%;
		height: 100%;
		background-color: rgba(51, 51, 51, .6);
		position: fixed;
		left: 0;
		top: 0;
		z-index: 99999;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.modal .modalBox {
		position: relative;
		width: 380px;
	}

	.modal .modalBox .closeBtn {
		position: absolute;
		right: -15px;
		top: -15px;
		width: 30px;
		height: 30px;
		border-radius: 15px;
		background-color: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.modal .modalBox .logo {
		position: absolute;
		right: 20px;
		top: -60px;
	}

	.isCompany {
		width: 380px;
		min-height: 530px;
		background: linear-gradient(to bottom, rgb(255, 223, 184) 0%, #ffffff 60%);
		border-radius: 5px;
		/* background: -webkit-gradient(linear, 10% 10%，100% 100%， color-stop(0.14, ),color-stop(0.5, rgb(255, 230, 212)),color-stop(1, rgb(255, 245, 217))); */
		/* background-image: url(https://cdn.hrwork.com/fore/duomi-official-pc/publish/build/static/media/qiyezixun-modal.a4f4a869.png); */
		background-size: cover;
		padding: 30px;
		box-sizing: border-box;
	}

	.isCompany .tImg {
		margin-bottom: 20px;
		font-size: 24px;
	}

	.isCompany .item {
		margin-top: 14px;
	}

	.isCompany input,
	.isCompany textarea {
		width: 300px;
		line-height: 40px;
		border-radius: 8px;
		border-color: transparent;
		padding: 0 10px;
		font-size: 14px;
	}

	.isCompany .subBtn {
		width: 320px;
		height: 50px;
		background-color: #ff8500;
		line-height: 50px;
		text-align: center;
		border-radius: 6px;
		color: #fff;
		font-size: 18px;
		margin-top: 20px;
		cursor: pointer;
	}


	.home {
		width: 100%;
		height: 100%;
	}

	.homepage {
		overflow-y: scroll;
		scrollbar-width: none;
		/* Firefox */
		-ms-overflow-style: none;
		/* IE 10+ */
	}

	.homepage::-webkit-scrollbar {
		/* WebKit */
		width: 0;
		height: 0;
	}

	.fullpage {
		height: auto;
		position: relative;
		margin-top: 54px;
	}

	.mySwiper {
		width: 100%;
	}

	.el-main {
		margin: 0;
		padding: 0;
	}

	.el-footer {
		background-color: #B3C0D1;
		color: #333;
		text-align: center;
		line-height: 60px;
	}

	.inner-box {
		width: 1200px;
		margin: 0 auto;
		position: relative;
	}

	.mySwiper .swiper-container {
		background-color: rgb(255, 255, 255);
		height: calc(100vh - 80px);
		padding-top: 80px;
	}

	.mySwiper .rightBar {
		position: fixed;
		left: 50%;
		top: 80%;
		width: 30px;
		height: 480px;
		margin-top: -240px;
		margin-left: 648px;
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
	}

	.mySwiper .rightBar .line {
		width: 2px;
		height: 260px;
		background-color: #e6e6e6;
	}

	.mySwiper .rightBar .line .activeLine {
		background-color: #ff8500;
		width: 2px;
	}

	.mySwiper .rightBar .bottom .advisor:hover .advisorBox {
		display: block;
	}

	.mySwiper .rightBar .bottom .advisor .advisorBox {
		background-image: url(../assets/advisory.png);
		width: 157px;
		height: 140px;
		background-size: cover;
		display: none;
		position: absolute;
		left: -157px;
		top: -50px;
		background-size: 157px 140px;
		padding: 12px 25px;
		background-repeat: no-repeat;
		box-sizing: border-box;
	}

	.mySwiper .rightBar .bottom .advisor .advisorBox .item {
		width: 100px;
		line-height: 40px;
		border: 1px solid transparent;
		margin-bottom: 10px;
		font-size: 14px;
		text-align: center;
		border-radius: 5px;
		background-color: #f7f8fa;
	}

	.mySwiper .rightBar .bottom .advisor .advisorBox .item:hover {
		border: 1px solid #FF8500;
		color: #FF8500;
		background-color: #fff;
	}

	.mySwiper .rightBar .bottom .program .programC {
		width: 391px;
		height: 140px;
		position: absolute;
		left: -391px;
		top: -50px;
		background-image: url(../assets/images/programs.png);
		background-size: contain;
		display: none;
	}

	.mySwiper .rightBar .bottom .program:hover .programC {
		display: block;
	}

	.mySwiper .rightBar .bottom .cellphone:hover .cellphoneC {
		display: block;
	}

	.mySwiper .rightBar .bottom .cellphone .cellphoneC {
		width: 170px;
		height: 60px;
		position: absolute;
		left: -170px;
		top: -8px;
		background-image: url(../assets/grey-phone.png);
		background-size: cover;
		display: none;
		font-size: 14px;
		color: #6d758a;
		font-weight: 400;
		line-height: 50px;
	}

	.mySwiper .rightBar .bottom .cellphone .cellphoneC img {
		margin: 18px 8px 0 25px;
	}
</style>


// WEBPACK FOOTER //
// src/views/home.vue